import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type {Menu} from '../../components/types/types';
export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}
export interface AuthState {
  tableauToken: string | null;
  user: User | null;
  token: string | null;
  role:Role[] | null;
  appConfig:AppConfig[] | null;
}

export interface Role {
    roleID: number;
    roleName: string;
    menu: Menu[];  
}

export interface AppConfig {
  configType: string;
  configName: string;
  configValue: string;
  environment: string;
  AppConfig: AppConfig[];  
}


const initialState: AuthState = {
  tableauToken: localStorage.getItem('tableauToken') ?? null,
  user: (() => {
    const userString = localStorage.getItem('user');
    if (userString === null) return null;
    try {
      return JSON.parse(userString) as User;
    } catch {
      return null;
    }
  })(),
  token: localStorage.getItem('jwtToken') ?? null,
  role: (() => {
    const userString = localStorage.getItem('role');
    if (userString === null) return null;
    try {
      return JSON.parse(userString) as Role[];
    } catch {
      return null;
    }
  })(),
  appConfig: (() => {
    const userString = localStorage.getItem('appConfig');
    if (userString === null) return null;
    try {
      return JSON.parse(userString) as AppConfig[];
    } catch {
      return null;
    }
  })()
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<AuthState>) => {
      state.tableauToken = action.payload.tableauToken;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.appConfig = action.payload.appConfig;
      if (action.payload.tableauToken !== null) {
        localStorage.setItem('tableauToken', action.payload.tableauToken);
      } else {
        localStorage.removeItem('tableauToken');
      }
      if (action.payload.user !== null) {
        localStorage.setItem('user', JSON.stringify(action.payload.user));
      } else {
        localStorage.removeItem('user');
      }
      if (action.payload.token !== null) {
        localStorage.setItem('jwtToken', action.payload.token);
      } else {
        localStorage.removeItem('jwtToken');
      }
      if (action.payload.role !== null) {
        localStorage.setItem('role',  JSON.stringify(action.payload.role));
      } else {
        localStorage.removeItem('role');
      }
      if (action.payload.appConfig !== null) {
        localStorage.setItem('appConfig',  JSON.stringify(action.payload.appConfig));
      } else {
        localStorage.removeItem('appConfig');
      }
      
    },
    clearAuthData: (state) => {
      state.tableauToken = null;
      state.user = null;
      state.token = null;
      state.role = null;
      state.appConfig = null;
      localStorage.removeItem('tableauToken');
      localStorage.removeItem('user');
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('role');
      localStorage.removeItem('appConfig');
    },
    updateTableauToken: (state) => {
      const sessionToken = localStorage.getItem('tableauToken');
      if (sessionToken != null) {
        state.tableauToken = sessionToken;
      }
    },
  },
});

export const { setAuthData, clearAuthData, updateTableauToken } = authSlice.actions;
export default authSlice.reducer;